import { Logger, LogManager } from "../logger/logger";
import { LanguageConst } from "./languageconst";
import { ThemeConst } from "./themeconst";
import { Strings } from './strings';
import { Colors } from './colors';
import { Fonts } from './fonts';
import { ApplicationBuild } from '../property/applicationbuild';
import { PropertyReader } from '../property/propertyreader';
import { BaseContext } from '../basecontext';

export interface Resources
{
    getString(key: any): string;
    getColor(key: any): string;
    getFont(key: any): string;
    getImage(imageName: string): string; 
    getFontFamily(): string;

    // updateLanguage(language: LanguageConst): void;
}

export class ResourcesImpl implements Resources
{
    private ivrResourcesLogger: Logger = LogManager.getLogger(ResourcesImpl.name);
    private stringsData: any;
    private colorsData: any;
    private fontsData: any;
    private fontFamily: any;
    private imagesURL: string;
    private propertyReader: PropertyReader;
    private count: number = 4;
    constructor(context: BaseContext)
    {
        this.ivrResourcesLogger.log("ResourcesImpl() invoked");

        this.propertyReader = new PropertyReader();
    }

    init(language: LanguageConst, theme: ThemeConst, resourcedLoaded: () => void)
    {
        this.ivrResourcesLogger.log("init() invoked");

        this.imagesURL = ApplicationBuild.getBaseURL() + 'assets/images/';
    
        this.updateLanguage(this.count, language, resourcedLoaded);
        this.updateTheme(theme, resourcedLoaded);
    }

    updateLanguage(count: number, language: LanguageConst, onResourceLoaded: () => void): void 
    {
        this.count = count;
        
        this.propertyReader.readProperty("assets/languages/" + language +'/strings.json', "application/json", 
        {
         onFailure: ()=>{
             throw new Error();
         }, 
         onSuccess: (propertiesData: any)=> 
         {
            this.setStringsData(propertiesData);

            this.count --; 
            console.log("---count in strings: " + this.count);
            if(this.count === 0)
            {
                onResourceLoaded();
            }
         }
        
        });
        this.propertyReader.readProperty("assets/languages/" + language +'/values.json', "application/json", 
        {
         onFailure: ()=>{
            throw new Error();
         }, 
         onSuccess: (propertiesData: any)=> 
         {
            this.setFontsData(propertiesData);

            this.count --; 
            console.log("---count in values: " + this.count);
            if(this.count === 0)
            {
                onResourceLoaded();
            }
         }
        
        });

        this.propertyReader.readProperty('assets/languages/' + 'fontfamilies.json', "application/json", 
        {
         onFailure: ()=>{
            throw new Error();
         }, 
         onSuccess: (propertiesData: any)=> 
         {
            this.setFontFamilyData(propertiesData, language);

            this.count --; 
            console.log("---count in fontfamily: " + this.count);
            if(this.count === 0)
            {
               onResourceLoaded();
            }
         }
        
        });
        // this.setStringsData(require(this.BASE_URL + language +'/strings.json'));
        // this.setFontsData(require(this.BASE_URL + language +'/values.json'));
        // this.setFontFamilyData(require(this.BASE_URL + 'languages/' + 'fontfamilies.json'), language);
    }

    updateTheme(theme: ThemeConst, onResourceLoaded: () => void): void
    {
        this.propertyReader.readProperty("assets/themes/" + theme +'/colors.json', "application/json", 
        {
         onFailure: ()=>{
            throw new Error();
         }, 
         onSuccess: (propertiesData: any)=> 
         {
            this.setColorsData(propertiesData);

            this.count --; 
            console.log("---count in theme: " + this.count);
            if(this.count === 0)
            {
               onResourceLoaded();
            }
         }
        
        });
        // this.setColorsData(require(this.BASE_URL + theme +'/colors.json'));
    }

    getString(key: Strings): string 
    {
        return this.stringsData[key];
    }

    getColor(key: Colors): string 
    {
        return this.colorsData[key];
    }

    getFontFamily(): string 
    {
        return this.fontFamily;
    }

    getFont(key: Fonts): string 
    {
        return this.fontsData[key];  
    }

    getImage(imageName: string): string {
        return this.imagesURL + imageName;
     }

    protected setStringsData(stringsData: any)
    {
        this.stringsData = stringsData;
    }
    
    protected setColorsData(colorsData: any)
    {
        this.colorsData = colorsData;
    }
    
    protected setFontsData(fontsData: any)
    {
        this.fontsData = fontsData;
    }

    protected setFontFamilyData(fontFamiliesData: any, language: LanguageConst)
    {
            this.fontFamily = fontFamiliesData[language];
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/resources/resources.ts